"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = FlexItem;
exports.flexPositions = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * @enum {string}
 * @alias FlexItem.flexPositions
 */
var flexPositions = {
  /** forceStart */
  FORCESTART: "forceStart",

  /** forceEnd */
  FORCEEND: "forceEnd",

  /** forceCenter */
  FORCECENTER: "forceCenter"
};
/**
 * @class FlexItem
 * @desc displays a FlexItem to be nested inside of FlexRow
 *
 * @param {string} [data-id]
 *     Defines the "data-id" for top-level HTML container.
 * @param {string} [className]
 *     Optional CSS classname(s) applied to top-level container.
 * @param {string} [grow]
 *    Specifies the proportions in which to distribute space.
 * @param {string} [shrink]
 *    Specifies the ratio of space an item should take up when the item is larger than it's parent container.
 * @param {string} [basis]
 *    Defines the inital size of a flex item.
 * @param {FlexItem.flexPositions} [flexPosition]
 *    Defines the placement of a flex item within its parent container.
 * @param {node} [children]
 *    A node that will appear in the component.
 * @example
 *     <FlexRow>
 *          <FlexItem> Lorem Ipsum </FlexItem>
 *     </FlexRow>
 */

exports.flexPositions = flexPositions;

function FlexItem(_ref) {
  var dataId = _ref["data-id"],
      className = _ref.className,
      children = _ref.children,
      grow = _ref.grow,
      shrink = _ref.shrink,
      basis = _ref.basis,
      flexPosition = _ref.flexPosition;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("flex-item", className, {
      "flex-item--force-end": flexPosition === flexPositions.FORCEEND,
      "flex-item--force-start": flexPosition === flexPositions.FORCESTART,
      "flex-item--force-center": flexPosition === flexPositions.FORCECENTER
    }),
    style: {
      flexGrow: grow ? grow : undefined,
      flexShrink: shrink ? shrink : undefined,
      flexBasis: basis ? basis : undefined
    },
    "data-id": dataId
  }, children);
}

FlexItem.propTypes = {
  "data-id": _propTypes.default.string,
  grow: _propTypes.default.string,
  shrink: _propTypes.default.string,
  basis: _propTypes.default.string,
  flexPosition: _propTypes.default.oneOf((0, _values.default)(flexPositions)),
  className: _propTypes.default.string
};